import { Player } from "@lottiefiles/react-lottie-player";
import { useRef } from "react";

const CakeLoader = () => {
    const player = useRef(null);
    const images = [
        "/images/loaders/1.json",
        "/images/loaders/2.json",
        "/images/loaders/3.json",
        "/images/loaders/4.json",
        "/images/loaders/5.json",
        "/images/loaders/6.json",
        "/images/loaders/7.json",
    ];

    const randomImage = getRandomItem(images);

    function getRandomItem(array: string[]) {
        const randomIndex = Math.floor(Math.random() * array.length);
        return array[randomIndex];
    }

    return (
        <div className="flex fixed inset-0 items-center justify-center z-[99999999999999999999999] bg-black bg-opacity-80">
            <div>
                <Player
                    ref={player}
                    autoplay={true}
                    loop={true}
                    controls={false}
                    src={`${window.origin}${randomImage}`}
                    style={{ height: "500px", width: "500px" }}
                ></Player>
                <p className="text-center text-white">Cargando</p>
            </div>
        </div>
    );
};

export default CakeLoader;
